import { isNil } from 'lodash-es';

export type ParamValue = string | number | boolean | undefined;
export type Params = { [key: string]: ParamValue };
export type ParamsArray = { array: ParamValue[]; paramKey: string };

const normalizeParamsArrays = (paramsArray?: ParamsArray | ParamsArray[]): ParamsArray[] => {
  if (!paramsArray) return [];
  return Array.isArray(paramsArray) ? paramsArray : [paramsArray];
};

const appendParamsArrays = (arrays: ParamsArray[], hasExistingParams: boolean): string => {
  const parts = arrays
    .map(({ array, paramKey }) => {
      const values = (array ?? []).filter(value => !isNil(value) && value !== '');
      if (!values.length) return null;
      return `${paramKey}=${values.join(`&${paramKey}=`)}`;
    })
    .filter(Boolean) as string[];

  if (!parts.length) return '';
  const joined = parts.join('&');
  return hasExistingParams ? `&${joined}` : joined;
};

type CreateUrlWithParams = (
  url: string,
  params?: Params,
  paramsArray?: ParamsArray | ParamsArray[],
  removeEmptyValues?: boolean,
) => string;

const createUrlWithParams: CreateUrlWithParams = (url, params, paramsArray, removeEmptyValues = true) => {
  if (!url) throw new Error('Url is required');
  if (!params) return url;

  const nextParams = { ...params };
  if (removeEmptyValues) {
    Object.entries(nextParams).forEach(([key, value]) => {
      if (isNil(value) || value === '') delete nextParams[key];
    });
  }

  const urlParams = new URLSearchParams(nextParams as unknown as URLSearchParams).toString();
  const arraysSuffix = appendParamsArrays(normalizeParamsArrays(paramsArray), Boolean(urlParams));

  if (!urlParams && !arraysSuffix) return url;
  if (!urlParams) return `${url}?${arraysSuffix}`;
  return `${url}?${urlParams}${arraysSuffix}`;
};

export default createUrlWithParams;
